import './index.less';

import request from '@/utils/request';
import { getLocaleText, setSearchHistory } from '@/utils/utils';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { Toast } from 'antd-mobile';
import { useEffect, useRef, useState } from 'react';
import { getLocale, useIntl } from 'umi';

import Code from '../Code';

const Verify = (props: any) => {
  const {
    visable,
    close,
    phone,
    type,
    setPicData,
    checkEmailImgCode,
    setPicCode,
  } = props;
  const [verify, setVerify] = useState<any>();
  const [data, setData] = useState<any>();
  const [codeVisable, setCodeVisable] = useState(false);
  const intl = useIntl();
  // 关闭当前弹窗
  const handleClose = () => {
    close();
  };
  // 关闭验证吗弹窗
  const codeClose = () => {
    setCodeVisable(false);
  };

  // 获取图片验证码
  const init = async () => {
    const Url = `${process.env.BMSUrl}bms/user/login/getPicCode?version=1`;
    const res = await request.post(Url, {
      data: {
        lang: `${getLocale().replace(/-/gi, '_')}`,
        accountId: phone,
        platformCode: `${process.env.BMSsiteId}`,
      },
    });
    setData(res?.data);
    setPicData && setPicData(res?.data);
  };

  useEffect(() => {
    try {
      init();
    } catch (error) {
      console.log(error);
    }
  }, []);
  // 获取验证码

  // 转码验证码
  function base64ToImage(base64String: any) {
    const byteCharacters = atob(base64String.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/png' });
    const imageUrl = URL.createObjectURL(blob);
    return imageUrl;
  }
  // 校验验证码
  function validateMacaoPhoneNumber(phoneNumber: any) {
    const macaoPhoneRegex = /^[0-9]\d{0,9}$/;
    return macaoPhoneRegex.test(phoneNumber);
  }
  // 校验图形验证码,获取验证码
  const checkImgCode = async () => {
    if (!verify) {
      Toast.info(
        intl.formatMessage({
          id: 'login.page.pleaseImgVerify',
        }),
      );
    } else {
      const isValidPhoneNumber = validateMacaoPhoneNumber(verify);
      if (isValidPhoneNumber) {
        if (type == 'email') {
          close();

          checkEmailImgCode();
        } else {
          setCodeVisable(true);
        }
      } else {
        Toast.info(
          intl.formatMessage({
            id: 'login.page.pleaseTrueImgVerify',
          }),
        );
      }
    }
  };
  // 重新获取
  const require = () => {
    codeClose();
    init();
    setVerify(' ');
  };
  return (
    <div>
      <Dialog
        className="verify"
        open={visable}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        disableEnforceFocus
        disableBackdropClick={true}
      >
        <div className="content">
          <DialogContent>
            <div className="title">
              <DialogContentText>
                {getLocaleText('login.page.check')}
              </DialogContentText>
              <DialogContentText className="please">
                {getLocaleText('login.page.answer')}
              </DialogContentText>
            </div>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              onChange={(v) => {
                setVerify(v.target.value),
                  setPicCode && setPicCode(v.target.value);
              }}
              type="email"
              fullWidth
              value={verify}
            />
            <div className="verify_content">
              {/* <div className='verify_code'> */}
              {data && <img src={base64ToImage(data.image)} alt="" />}
              {/* </div> */}

              <Button onClick={init} color="primary" className="button">
                {getLocaleText('login.page.next')}
              </Button>
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={close} color="primary">
              {getLocaleText('login.page.back')}
            </Button>
            <Button onClick={() => checkImgCode()} color="primary">
              {getLocaleText('login.page.sure')}
            </Button>
          </DialogActions>
        </div>
      </Dialog>
      {codeVisable && (
        <Code
          visable={codeVisable}
          close={codeClose}
          phone={phone}
          verify={verify}
          PicData={data}
          require={require}
        />
      )}
    </div>
  );
};

export default Verify;
